import { Box, CircularProgress } from "@mui/material";

type AssessmentLoadingStateProps = {
  testId?: string;
};

export function AssessmentLoadingState({
  testId = "assessment-loading",
}: AssessmentLoadingStateProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 4,
        width: "100%",
        minHeight: "100dvh",
      }}
    >
      <CircularProgress aria-label="Loading assessment" data-testid={testId} />
    </Box>
  );
}
